import React, { useEffect, useRef, useState } from 'react';
import { getData, getImage } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import HomeScreen from './home';
import BuffetScreen from './buffet';
import CumpleScreen from './cumple';


function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);

    const [showHome, setShowHome] = useState(false);
    const [showBuffet, setShowBuffet] = useState(false);
    const [showCumple, setShowCumple] = useState(false);

    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showHappy, setShowHappy] = useState(false);
    const [showExecutiveMenu, SetshowExecutiveMenu] = useState(false);
    const [showBar, setShowBar] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [dataFood, setDataFood] = useState(false);

    const [screenSavers, setScreenSavers] = useState(null);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [saverUrls, setSaverUrls] = useState({});
    const dragStartX = useRef(null);
    const hasDragged = useRef(false);
    
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);



      useEffect(() => {
              menus.map((item) => {
                  if (item.id === 435) {
                  setDataFood(item);
                  }
             
             
              });
      }, [menus]);
    
    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowHome(false)
             getInitData()

        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);



    useEffect(() => {
        getData('screen_savers').then((items) => {
            if (items && items.value) {
                setScreenSavers(items.value);
            } else {
                setScreenSavers([]);
            }
        }).catch(() => setScreenSavers([]));
    }, [change]);

    useEffect(() => {
        if (!screenSavers || screenSavers.length === 0) return;
        screenSavers.forEach(async (item) => {
            const id = `screen-saver-${item.id}`;
            try {
                const stored = await getImage(id);
                if (stored && stored.data && stored.data.blob) {
                    const url = URL.createObjectURL(stored.data.blob);
                    setSaverUrls(prev => ({ ...prev, [id]: url }));
                }
            } catch (e) {}
        });
    }, [screenSavers]);

    useEffect(() => {
        if (!screenSavers || screenSavers.length <= 1) return;
        const interval = setInterval(() => {
            setCurrentSlide(prev => (prev + 1) % screenSavers.length);
        }, 3000);
        return () => clearInterval(interval);
    }, [screenSavers]);

    const handleDragStart = (e) => {
        hasDragged.current = false;
        dragStartX.current = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
    };

    const handleDragEnd = (e) => {
        if (dragStartX.current === null) return;
        const endX = e.type === 'touchend' ? e.changedTouches[0].clientX : e.clientX;
        const diff = dragStartX.current - endX;
        if (Math.abs(diff) > 50) {
            hasDragged.current = true;
            if (diff > 0) setCurrentSlide(prev => (prev + 1) % screenSavers.length);
            else setCurrentSlide(prev => (prev - 1 + screenSavers.length) % screenSavers.length);
        }
        dragStartX.current = null;
    };

    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };


    return (
        <div style={{width: '100%', height: '100%'}}>

            {screenSavers !== null && screenSavers.length === 0 && !showHome && (
                <HomeScreen setShowBar={setShowBar} />
            )}

            {screenSavers !== null && screenSavers.length > 0 && (
                <div
                    onClick={() => { if (!hasDragged.current) setShowHome(true); }}
                    onMouseDown={handleDragStart}
                    onMouseUp={handleDragEnd}
                    onTouchStart={handleDragStart}
                    onTouchEnd={handleDragEnd}
                    style={{
                        position: 'fixed', top: 0, left: 0,
                        width: '100vw', height: '100vh',
                        cursor: 'pointer', zIndex: 1, overflow: 'hidden',
                    }}
                >
                    {screenSavers.map((item, index) => {
                        const id = `screen-saver-${item.id}`;
                        return (
                            <img
                                key={item.id}
                                onContextMenu={(e) => e.preventDefault()}
                                src={saverUrls[id] || `https://tumenu.online/images/screen_savers/${item.image}`}
                                style={{
                                    position: 'absolute', top: 0, left: 0,
                                    width: '100%', height: '100%',
                                    objectFit: 'cover',
                                    pointerEvents: 'none',
                                    opacity: index === currentSlide ? 1 : 0,
                                    transition: 'opacity 0.5s ease',
                                }}
                                alt=""
                            />
                        );
                    })}
                    {screenSavers.length > 1 && (
                        <div style={{
                            position: 'absolute', bottom: 20, left: 0, width: '100%',
                            display: 'flex', justifyContent: 'center', gap: 8,
                            pointerEvents: 'none', zIndex: 2,
                        }}>
                            {screenSavers.map((_, i) => (
                                <div key={i} style={{
                                    width: 10, height: 10, borderRadius: '50%',
                                    background: i === currentSlide ? '#fff' : 'rgba(255,255,255,0.5)',
                                }} />
                            ))}
                        </div>
                    )}
                </div>
            )}

            {showBuffet && <BuffetScreen setShowBuffet={setShowBuffet} />}
            {showCumple && <CumpleScreen setShowBuffet={setShowCumple} />}
            {showHome && <HomeScreen setShowBar={setShowBar} />}
        </div>
          
           
    );
}

export default Index;